// extracted by mini-css-extract-plugin
export default {"pill":"Rji6jkNa","live":"FAQALNh6","dot":"LXnNxrxe","dormant":"XtwFvTJg","label":"Nu2rITBj"};